import React from "react";
import ReactDOM from "react-dom/client";
import { initAnalytics, trackEvent } from "./utils/analytics";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import CookieConsentBanner from "./layout/CookieConsentBanner/CookieConsentBanner";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fontsource/source-serif-4/600.css";
import "./styles/PrincipalFx.css";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Iniciar analíticas de forma diferida (tras load / interacción / idle)
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <CookieConsentBanner /> */}
    <App />
  </React.StrictMode>
);

function sendToAnalytics({ id, name, value }) {
  trackEvent({
    category: "Web Vitals",
    action: name,
    label: id,
    value: Math.round(name === "CLS" ? value * 1000 : value), // Multiplica CLS por 1000
    nonInteraction: true, // Opcional: flag para evitar afectar la tasa de rebote
  });
}

reportWebVitals(sendToAnalytics);

// Desactivar Service Worker y limpiar cachés en navegadores que lo hayan registrado previamente
serviceWorkerRegistration.unregister();

